export class CourseRatio {
  id: string;
  numberOfStudentsPerInstructor: number;
  numberOfStudentsPerInstructorText: string;
  classDuration: number;
  numberOfCourses: number;
  checked = true;
}
